export default __webpack_public_path__ + "static/applying-grid-light-cf0c4d8b8087301537f751619c846efb.png";